module.exports = __webpack_public_path__ + "static/media/download_DANI.130537a5.svg";